import { getBackVersion } from '../../../config';
import api from '../../api';
import { RentAdvanceFileSnapshot } from '../../../models/LandlordArea/RentAdvance';

const getFile = (rentAdvanceId: number): Promise<RentAdvanceFileSnapshot> =>
    api.request<RentAdvanceFileSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/landlord_area/rent_advances/${rentAdvanceId}/files`,
    });

const setFile = (
    rentAdvanceId: number,
    s3Path: string,
    filename: string
): Promise<RentAdvanceFileSnapshot> =>
    api.request<RentAdvanceFileSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/landlord_area/rent_advances/${rentAdvanceId}/files`,
        // eslint-disable-next-line camelcase
        data: { s3_path: s3Path, filename },
    });

export { setFile, getFile };
